export interface FeedbackViewInterface {
  feedbackId: string;
  rating: number;
  feedbacks: string;
  createdBy: string;
  createdOn: Date;
  organisation: string;
}

// todo need to use FeedbackInterface instead
export class CreateFeedback {
  rating: number;
  feedback: string;
  feedbackType: string;
  businessUnitId: string;
  createdBy: string;
  userBusinessUnitId: string;
}

export class FeedbackInterface {
  rating: number;
  feedback: string;
  feedbackType: string;
  businessUnitId: string;
  createdBy: string;
  userBusinessUnitId: string;
}
